export const notIdentity = (v?: any) => !v
